import { API_PATH } from '../constants/api';
import { fetchApi } from '../http-request';
import { DynamicObject } from '../types/api/commons';
import {
  TParamsGetVendorPrice,
  TPayloadInviteVendor,
} from '../types/api/vendor';
import { cleanObject } from '../utils';

export const getListMasterVendor = async (params: unknown) => {
  try {
    const cleanParams = cleanObject(params);
    const urlParams = new URLSearchParams(cleanParams).toString();

    const response = await fetchApi(`${API_PATH.vendor.list}?${urlParams}`);
    return response.data?.data || [];
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteVendorRequest = async (payload: unknown) => {
  try {
    const response = await fetchApi.put(API_PATH.vendor.delete, payload);
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const getDetailVendor = async (id: string) => {
  try {
    const response = await fetchApi(
      `${API_PATH.vendor.detail.replace(':id', id)}`
    );
    const data = response?.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data.data || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createVendorRequest = async ({ payload }: DynamicObject) => {
  try {
    const response = await fetchApi.post(API_PATH.vendor.add, payload, {
      withRequestId: true,
    });
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const editVendorRequest = async ({ payload }: DynamicObject) => {
  try {
    const response = await fetchApi.put(API_PATH.vendor.edit, payload);
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const postValidateUploadVendor = async (payload: unknown) => {
  try {
    const response = await fetchApi.post(
      API_PATH.vendor.validateUpload,
      payload,
      {
        withRequestId: true,
      }
    );
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const postAddVendor = async (payload: unknown) => {
  try {
    const response = await fetchApi.post(API_PATH.vendor.add, payload, {
      withRequestId: true,
    });
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const inviteVendor = async (payload: TPayloadInviteVendor) => {
  try {
    const response = await fetchApi.put(
      `${API_PATH.vendor.invitation}/${payload.vendorId}`,
      { reason: payload.reason, type: payload.type }
    );
    const data = response?.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data?.data || null;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const getVendorData = async (token: string) => {
  try {
    const response = await fetchApi(API_PATH.vendor.invitation, {
      headers: {
        'X-Api-Key': token,
      },
    });
    const data = response?.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data?.data || null;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const getListVendorPrices = async (params: TParamsGetVendorPrice) => {
  const cleanParams = cleanObject(params);
  const urlParams = new URLSearchParams(cleanParams).toString();

  const response = await fetchApi(`${API_PATH.vendor.priceList}?${urlParams}`);

  return response.data?.data;
};

export const getTemplatePriceList = async () => {
  const response = await fetchApi(API_PATH.vendor.generatePriceListTemplate);

  return response.data?.data;
};

export const postValidateVendorPriceList = async (payload: unknown) => {
  try {
    const response = await fetchApi.post(
      API_PATH.vendor.validatePriceList,
      payload,
      {
        withRequestId: true,
      }
    );
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const postSubmitPriceList = async (payload: unknown) => {
  try {
    const response = await fetchApi.post(
      API_PATH.vendor.createPriceList,
      payload,
      {
        withRequestId: true,
      }
    );
    const data = response.data;
    if ([200, 201].indexOf(data.statusCode) === -1) {
      throw new Error(data.message);
    }
    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};
